import { EventEmitter, ElementRef, Directive, NgZone, OnDestroy } from '@angular/core';
import Draggable from '@telerik/kendo-draggable';

/**
 * @hidden
 */
@Directive({
  standalone: false,
  outputs: ['kendo.press', 'kendo.drag', 'kendo.release'] /* eslint-disable-line */,
  selector: '[kendoLayoutDraggable]',
})
export class DraggableDirective implements OnDestroy {
  public kendo: any = {
    drag: new EventEmitter(),
    press: new EventEmitter(),
    release: new EventEmitter(),
  };

  constructor(
    private zone: NgZone,
    element: ElementRef,
  ) {
    if (typeof document !== 'undefined') {
      this.draggable = new Draggable({
        drag: (e: any): void => this.kendo.drag.next(e),
        press: (e: any): void => this.kendo.press.next(e),
        release: (e: any): void => this.kendo.release.next(e),
      });

      this.zone.runOutsideAngular(() => this.draggable.bindTo(element.nativeElement));
    }
  }

  public ngOnDestroy(): void {
    if (typeof document !== 'undefined') {
      this.draggable.destroy();
    }
  }

  private draggable: Draggable;
}
